import { cn } from '@pantry/ui';

/**
 * Circular health ring visualization
 */
export function HealthRing({
  percentage,
  size,
  isLoading,
}: {
  percentage: number;
  size: number;
  isLoading: boolean;
}) {
  const strokeWidth = 8;
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const offset = circumference - (percentage / 100) * circumference;

  return (
    <svg width={size} height={size} className="transform -rotate-90">
      {/* Background circle */}
      <circle
        cx={size / 2}
        cy={size / 2}
        r={radius}
        fill="none"
        stroke="currentColor"
        strokeWidth={strokeWidth}
        className="text-muted/30"
      />
      {/* Progress circle */}
      {!isLoading && (
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="currentColor"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          className={cn(
            'transition-all duration-1000 ease-out',
            percentage >= 70
              ? 'text-fresh'
              : percentage >= 40
                ? 'text-expiring-soon'
                : 'text-expired'
          )}
        />
      )}
    </svg>
  );
}
